import request from '@/utils/request'
import { getCommunityId } from '@/api/community/communityApi'
import { getUserId } from '@/api/user/userApi'

// 查询报修工单池
export function listRepairPools(params) {
  return new Promise((resolve, reject) => {
    // 获取用户信息，用于获取handlerKey
    let handlerKey = params.handlerKey
    if (!handlerKey) {
      try {
        const userInfo = JSON.parse(localStorage.getItem('user'))
        handlerKey = userInfo.pgId || userInfo.handlerKey || ''
      } catch (e) {
        console.warn('Failed to get handlerKey from user info:', e)
      }
    }
    
    const baseParams = {
      communityId: getCommunityId(),
      initiatorType: params.initiatorType || '1',
      userId: getUserId(),
      handlerKey: handlerKey || '',
      page: params.page || 1,
      row: params.row || 10,
      tabType: params.tabType !== undefined && params.tabType !== null ? params.tabType : '3'
    }
    
    const queryParams = { ...baseParams, ...params }
    
    if (queryParams.state === 'TIMEOUT') {
      queryParams.state = ''
      queryParams.timeoutFlag = 'Y'
    }
    
    request({
      url: '/app/pms.queryRepairOrder',
      method: 'get',
      params: queryParams
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || 'Failed to fetch repair pools'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 派单
export function dispatchRepair(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/callComponent/ownerRepair.repairDispatch',
      method: 'post',
      data: {
        ...data,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || 'Dispatch failed'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 结束工单
export function endRepair(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/ownerRepair.repairEnd',
      method: 'post',
      data: {
        ...data,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || 'End repair failed'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 更新业主报修
export function updateOwnerRepair(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/ownerRepair.updateOwnerRepair',
      method: 'post',
      data: {
        ...data,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || 'Update failed'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除业主报修
export function deleteOwnerRepair(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/ownerRepair.deleteOwnerRepair',
      method: 'post',
      data: {
        ...data,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || 'Delete failed'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}



// 删除业主报修
export function deleteOrder(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/pms.deleteOrder',
      method: 'post',
      data: {
        ...data,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || 'Delete failed'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 抢单
export function grabbingRepair(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/ownerRepair.grabbingRepair',
      method: 'post',
      data: {
        ...data,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || 'Grab order failed'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 执行工单流程
export function executeFlowProcess(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/app/pms.executeFlowProcess',
      method: 'post',
      data: {
        ...params,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '执行流程失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 根据专业ID查询可指派人员（categoryId = professionId）
export function getUserByCategoryId(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/app/user.getUserByCategoryId',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '获取人员列表失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 保存或更新报修工单（用于更新保修期等字段）
export function saveOrUpdateRepairOrder(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/app/pms.saveOrUpdateRepairOrder',
      method: 'post',
      data: {
        ...data,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '提交失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 转投诉单
export function repairChangeComplaint(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/app/pms.repairChangeComplaint',
      method: 'post',
      data: {
        ...data,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '转投诉单失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 投诉转工单（complaint -> repair）
export function complaintChangeRepair(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/app/pms.complaintChangeRepair',
      method: 'post',
      data: {
        ...data,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '投诉转工单失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}